import { getCurrentInstance, onBeforeUnmount } from 'vue'
import { navigateTo } from '#app'
import { useQueryClient } from '@tanstack/vue-query'
import { useInpostPay } from '~~/app/composables/useInpostPay'

let _subscribed = false
let _unsubscribe: (() => void) | null = null
let _refCount = 0

export function useInpostPayOrderConfirmation() {
  const { listenForOrderCreated } = useInpostPay()
  const queryClient = useQueryClient()

  _refCount += 1

  if (!_subscribed) {
    _subscribed = true
    _unsubscribe = listenForOrderCreated((event) => {
      queryClient.invalidateQueries({ queryKey: ['store', 'cart'] })
      // order_id dokładamy tylko, gdy znamy numer; przy fallbacku (pusty orderId)
      // przekierowujemy bez niego — strona /thank-you obsługuje brak numeru (v-if).
      const orderIdParam = event.orderId ? `order_id=${event.orderId}&` : ''
      navigateTo(`/thank-you?${orderIdParam}source=inpostpay`)
    })
  }

  const instance = getCurrentInstance()
  if (instance) {
    onBeforeUnmount(() => {
      _refCount -= 1
      if (_refCount === 0 && _unsubscribe) {
        _unsubscribe()
        _unsubscribe = null
        _subscribed = false
      }
    })
  }
}
